/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type AdVehicleStreamAlertVehicleMapVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  inService: boolean | null
  notInServiceReasons: Array<Types.NotInServiceReason> | null
  latestLocation: {
    __typename?: 'VehicleLocation'
    heading: number | null
    timestamp: string | null
    location: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    } | null
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    id: string
    stop: {
      __typename?: 'Stop'
      routingLocation: {
        __typename?: 'Location'
        latitude: number
        longitude: number
      }
    } | null
  }> | null
}

export type AdVehicleStreamAlertVehicleMapWaypointFragment = {
  __typename?: 'FccWaypoint'
  id: string
  stop: {
    __typename?: 'Stop'
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
}

export type AdVehicleStreamAlertVehicleMapLocationFragment = {
  __typename?: 'Location'
  latitude: number
  longitude: number
}

export const AdVehicleStreamAlertVehicleMapLocationFragmentDoc = gql`
    fragment AdVehicleStreamAlertVehicleMapLocation on Location {
  latitude
  longitude
}
    `
export const AdVehicleStreamAlertVehicleMapWaypointFragmentDoc = gql`
    fragment AdVehicleStreamAlertVehicleMapWaypoint on FccWaypoint {
  id
  stop {
    routingLocation {
      ...AdVehicleStreamAlertVehicleMapLocation
    }
  }
}
    ${AdVehicleStreamAlertVehicleMapLocationFragmentDoc}`
export const AdVehicleStreamAlertVehicleMapVehicleFragmentDoc = gql`
    fragment AdVehicleStreamAlertVehicleMapVehicle on Vehicle {
  id
  inService
  notInServiceReasons
  latestLocation {
    location {
      ...AdVehicleStreamAlertVehicleMapLocation
    }
    heading
    timestamp
  }
  fccUpcomingWaypoints {
    ...AdVehicleStreamAlertVehicleMapWaypoint
  }
}
    ${AdVehicleStreamAlertVehicleMapLocationFragmentDoc}
${AdVehicleStreamAlertVehicleMapWaypointFragmentDoc}`
